import api from '../services/api';
import swal from 'sweetalert2';

/* init */
const apiService = new api();

export default{

    props: ['show'],

    data() {
        return {
            password: '',
            repeatPassword: ''
        };
    },

    methods: {
        close() {
            this.$emit('close');
            this.password = '';
            this.repeatPassword = '';
        },

        submit() {
            let app = this;

            apiService.changePassword(this.password)
            .then((response) => {
                app.close();
                swal('Success', "You've successfully changed password!", 'success');
            })
            .catch((error) => {
                app.close();
                swal('Error', error.response.data.message, 'error');
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/modals/ChangePasswordModal.js